module.exports = "<div class=block-title>Comments</div> <ul class=notes-list> <li data-ng-repeat=\"note in $ctrl.notes track by $index\"> <div> <span class=\"notes-list__title block-bordered-hover\" ng-click=\"$ctrl.editNoteDialog($event, note)\" data-ng-bind=note.content></span> <md-icon ng-click=\"$ctrl.removeNote($index, note.id)\" class=\"material-icons notes-list__remove\">clear</md-icon> </div> </li> </ul> <a href=\"\" ng-click=\"$ctrl.addNoteDialog($event); $event.preventDefault();\" class=\"md-primary md-caption\">+ Add comment</a> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/thing-details/notes/notes.html
// module id = p7fo
// module chunks = 1